// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CheckDTO
 */
export interface CheckDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    referenceId: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    onfidoCheckId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    onfidoReportId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    type: CheckDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    status: CheckDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDTO
     */
    completedAt?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CheckDTOTypeEnum {
    IDENTITY = 'IDENTITY',
    CREDIT = 'CREDIT'
}
/**
    * @export
    * @enum {string}
    */
export enum CheckDTOStatusEnum {
    EMPTY = 'EMPTY',
    PEND = 'PEND',
    INFOREQUIRED = 'INFO_REQUIRED',
    INREVIEW = 'IN_REVIEW',
    PASS = 'PASS',
    FAIL = 'FAIL',
    CANCELLED = 'CANCELLED'
}



